import i18n from 'config/i18n/i18n';
import {loyaltyApolloClientWithToken, productApolloClient} from 'utils';

import {ECODE_ACTIVATION, GET_RM3_PROMOTION} from './queries';
import {PromoAdvice} from '../../types';

export const redeemEcode = async (code: string, idToken: string) => {
  try {
    const client = loyaltyApolloClientWithToken(idToken);
    const {data, errors} = await client.mutate({
      mutation: ECODE_ACTIVATION,
      variables: {
        code
      },
      errorPolicy: 'all'
    });
    return {data, errors};
  } catch (error: any) {
    return null;
  }
};

export const getRmPromotions = async (
  skus: string[],
  storeCodes: string[]
): Promise<Record<string, {promoAdvice: PromoAdvice[]; loading: boolean}> | undefined> => {
  const promoMap: Record<string, {promoAdvice: PromoAdvice[]; loading: boolean}> = {};
  skus
    .filter((sku) => !!sku && sku !== 'null')
    .forEach((itemId) => {
      promoMap[itemId] = {promoAdvice: [], loading: true};
    });

  try {
    const client = productApolloClient();
    const result = await client.mutate({
      mutation: GET_RM3_PROMOTION,
      variables: {
        lang: i18n.language,
        conditionFilter: 'ALL',
        storeCodes,
        makroIds: skus.filter((sku) => !!sku && sku !== 'null')
      },
      errorPolicy: 'all'
    });

    if (result?.data?.getRM3Promotions) {
      const response = result.data.getRM3Promotions;
      for (const promoAdvice of response) {
        if (!promoMap[promoAdvice.itemId]) {
          promoMap[promoAdvice.itemId] = {promoAdvice: [], loading: true};
        }
        const specificPromoRecord = promoMap[promoAdvice.itemId];
        specificPromoRecord.promoAdvice.push(promoAdvice);
      }
    }
  } catch (e) {
    Object.keys(promoMap).forEach((itemId) => {
      promoMap[itemId].loading = false;
    });
    return promoMap;
  }

  Object.keys(promoMap).forEach((itemId) => {
    promoMap[itemId].loading = false;
  });
  return promoMap;
};
